/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Standalone_Field_PriceInputs */

const cs_social_standalone_field_price = /** @type {(inputs: Social_Standalone_Field_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena (volitelné)`)
};

const en_social_standalone_field_price = /** @type {(inputs: Social_Standalone_Field_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price line (optional)`)
};

/**
* | output |
* | --- |
* | "Price line (optional)" |
*
* @param {Social_Standalone_Field_PriceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_standalone_field_price = /** @type {((inputs?: Social_Standalone_Field_PriceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Standalone_Field_PriceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_standalone_field_price(inputs)
	return cs_social_standalone_field_price(inputs)
});